<template>
  <div class="logo-wrp">
      <router-link to="/">
            <img v-if="logoUrl" :src="logoUrl" alt="capitalC logo" class="logo-img">
      </router-link>
  </div>
</template>

<script>
export default {

    computed:{
        logoUrl(){
            return require('../../assets/img/' + this.$route.meta.logo.logoUrl)
        }  
    }
}
</script>

<style>
.logo-img{
    width:197px;
    height: 50px;
}

.logo-wrp{
    margin-right: auto;
}

@media screen and (max-width: 800px){
    .logo-img{
        width:148px;
        height: 38px;
    }
}
</style>